import { LoginFailedOptions, LoginType, GoToOptions as VanillaGoToOptions } from '@frontend/vanilla/core';

/**
 * @whatItDoes Represents an event triggered when the login fails.
 *
 * @stable
 */
export class LoginFailedEvent {
    reason: { errorCode?: string; [x: string]: any } | undefined;
    loginType: LoginType | undefined;

    constructor(options: LoginFailedOptions) {
        if (options) {
            this.reason = options.reason;
            this.loginType = options.type;
        }
    }
}

/** @stable */
export interface GoToOptions extends VanillaGoToOptions {
    ignoreSpecialNativeHandling?: boolean;
    referrerNeedsLoggedInUser?: boolean;
    origin?: string;
    loginMessageKey?: string;
}

/** @stable */
export enum LoginErrorCode {
    DUPLICATE_EMAIL = '604',
    SELF_EXCLUSION = '699',
    SELF_EXCLUSION_COOL_OFF = '1750',
    SELF_EXCLUSION_RG_CLOSED = '101',
    SELF_EXCLUSION_GAMSTOP_RG_CLOSED = '102',
    SELF_EXCLUSION_UNKNOWN_ERROR = '610',
}

export interface TabbedLoginAction {
    categoryEvent?: string;
    actionEvent?: string;
    labelEvent?: string;
    locationEvent?: string;
    positionEvent?: string;
    eventDetails?: string;
}
